import { confirm } from 'devextreme/ui/dialog';
import React from 'react';
import { useHistory } from 'react-router';
import { deleteApi } from '../../apiUtils';
import { useTranslation } from '../../contexts/translation';
import { Columns } from '../../pages/AttachmentCategory/Columns';
import { API_URL } from '../../utils/apiUrl';
import { SisDataGrid } from '../table';
import { IDataGrid } from './AssetsDataGrid';

export const AttachmentCategoriesDataGrid = ({ data, handleEdit, mutateData }: IDataGrid) => {
  const { translate } = useTranslation();
  const transFormName = 'AttachmentCategory.List';
  const history = useHistory();

  const onToolbarPreparing = (e) => {
    e.toolbarOptions.items.unshift(
      {
        location: 'before',
        html: translate!('Attachment categories', transFormName),
      },
      {
        location: 'after',
        widget: 'dxButton',
        options: {
          icon: 'add',
          type: 'default',
          stylingMode: 'contained',
          onClick: () => history.push(`/attachment-categories/new/`),
        },
      },
    );
  };

  /** Kategorie použitá u přílohy se na BE nemaže, jen skryje. */
  const handleRemove = async (cellData) => {
    const id = cellData?.data?.id;
    if (!id) return;
    if (
      !(await confirm(
        translate!('Are you sure you want to delete attachment category?', transFormName),
        translate!('Confirm', ''),
      ))
    )
      return;

    await deleteApi({
      url: API_URL.ATTACHMENT_CATEGORY_DELETE,
      id,
      callAfterSuccess: () => mutateData && mutateData(),
    });
  };

  return (
    <SisDataGrid
      data={data}
      keyExpr={'id'}
      transFormName={transFormName}
      columns={Columns(handleEdit, handleRemove, translate)}
      onCellDblClick={(e) => handleEdit && handleEdit(e)}
      columnChooser={false}
      allowColumnResizing={false}
      allowColumnReordering={false}
      onToolbarPreparing={onToolbarPreparing}
      enableGrouping
      pageSizeChangeVisible
    />
  );
};
